import { render, staticRenderFns } from "./SsoButton.vue?vue&type=template&id=4ba60503&scoped=true"
import script from "./SsoButton.vue?vue&type=script&lang=ts"
export * from "./SsoButton.vue?vue&type=script&lang=ts"
import style0 from "./SsoButton.vue?vue&type=style&index=0&id=4ba60503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba60503",
  null
  
)

export default component.exports